/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespIconBubbles_item = {
    readonly isPublishedPrivate: boolean | null;
    readonly isJewelry: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubblePinterest_item" | "PdpSharedIconBubbleFacebook_item" | "PdpSharedIconBubbleEmail_item">;
    readonly " $refType": "PdpRespIconBubbles_item";
};
export type PdpRespIconBubbles_item$data = PdpRespIconBubbles_item;
export type PdpRespIconBubbles_item$key = {
    readonly " $data"?: PdpRespIconBubbles_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPublishedPrivate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelry",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'fb77aceb3ec34a7306145401bbc2c343';
export default node;
